import React, { useContext, useState } from 'react';
import {
  Box,
  Container,
  Card,
  CardHeader,
  Divider,
  CardContent,
  Tabs,
  Tab,
} from '@mui/material';
import PicksTable from './PicksTable';
import { Pick } from 'src/models';
import { CycleContext } from 'src/context/CycleContext';

type TabPanelProps = {
  children?: React.ReactNode;
  index: number;
  value: number;
};

const TabPanel = (props: TabPanelProps) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 0 }}>{children}</Box>}
    </div>
  );
};

const a11yProps = (index: number) => {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
};

type PicksCardProps = {
  firstRoundPicks: Pick[];
  secondRoundPicks: Pick[];
  thirdRoundPicks: Pick[];
  fourthRoundPicks: Pick[];
};

const PicksCard = ({
  firstRoundPicks,
  secondRoundPicks,
  thirdRoundPicks,
  fourthRoundPicks,
}: PicksCardProps) => {
  const cycle = useContext(CycleContext);
  const [tab, setTab] = useState(cycle.activeRound - 1);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
  };

  return (
    <Container maxWidth='sm' sx={{ mt: 3 }}>
      <Card>
        <CardHeader
          title='MY PICKS'
          titleTypographyProps={{ flex: '1 1 100%', variant: 'h6' }}
        />
        <Divider />
        <CardContent>
          <Tabs
            variant='fullWidth'
            value={tab}
            onChange={handleTabChange}
            aria-label='mypicks round tabs'
          >
            <Tab
              label='RD 1'
              {...a11yProps(0)}
              disabled={!firstRoundPicks.length}
            />
            <Tab
              label='RD 2'
              {...a11yProps(1)}
              disabled={!secondRoundPicks.length}
            />
            <Tab
              label='RD 3'
              {...a11yProps(2)}
              disabled={!thirdRoundPicks.length}
            />
            <Tab
              label='RD 4'
              {...a11yProps(3)}
              disabled={!fourthRoundPicks.length}
            />
          </Tabs>
          <TabPanel value={tab} index={0}>
            <PicksTable picks={firstRoundPicks} />
          </TabPanel>
          <TabPanel value={tab} index={1}>
            <PicksTable picks={secondRoundPicks} />
          </TabPanel>
          <TabPanel value={tab} index={2}>
            <PicksTable picks={thirdRoundPicks} />
          </TabPanel>
          <TabPanel value={tab} index={3}>
            <PicksTable picks={fourthRoundPicks} />
          </TabPanel>
        </CardContent>
      </Card>
    </Container>
  );
};

export default PicksCard;
